import { dateMinusDays } from './helpers'

/**
 * Collector for adding search functionality on top of existing table collector
 * @param {*} tableConfig 
 * @returns 
 */
 export function getTableCollector(tableConfig, search) {
    if (!tableConfig.searchEnabled || !search) {
        return tableConfig.collector
    }

    return function(row) {
        return tableConfig.collector(row) && getSearchCollector(search)(row)
    }
}

/**
 * Collector for comparing if file upload is newer than given date
 * @param {*} compareDate 
 * @returns 
 */
export function getDateCompareCollector(daysBeforeAllowed, ignoreBeforeString) {
    return function(row) {
        const fileDate = new Date(row.dateCreated)
        const compareDate = dateMinusDays(new Date(), daysBeforeAllowed)
        const ignoreBefore = new Date(ignoreBeforeString)
        
        if (fileDate > compareDate && ignoreBefore < fileDate) {
            return true
        }

        return false
    }
}

/**
 * Collector for finding files marked with important flag
 * @returns 
 */
export function getImportantCollector() {
    return function(row) {
        return row.important
    }
}

/**
 * Collector for filtering by name or description
 * @param {*} filter 
 * @returns 
 */
export function getSearchCollector(filter) {
    return function(row) {
        if (filter && filterRow(row, filter)) {
            return true
        }

        return false
    }
}

/**
 * Collector for collecting all results
 * @returns 
 */
export function getAllCollector() {
    return function() { return true }
}

/**
 * Filters row by description and path if they match filter parameter
 * @param {*} row 
 * @param {*} filter 
 * @returns true if matches
 */
 export function filterRow(row, filter) {
    if (!filter || !row) return false

    if (row.text && row.text.toLowerCase().indexOf(filter.toLowerCase()) !== -1) {
        return true
    }

    if (row.index && row.index === filter) {
        return true
    }

    return false
}